module.exports = __webpack_public_path__ + "static/media/DooExchangeColor.93e3eab4.svg";